module.exports = require("@swa-ui/itinerary/src/TripTypeDrawer/TripTypeDrawer.module.scss");